<material-navbar
  [menuPosition]="settings.get('vebto.navbar.defaultPosition', 'homepage-navbar')"
>
</material-navbar>

<ng-container
    *ngIf="paymentDetail$ | async as paymentDetail; else loadingSpinner"
>
    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="card">
                    <mat-icon class="color-green" svgIcon="check"></mat-icon>
                    <h1>Payment Successful</h1>
                    <div class="user-details">
                        <h3>Thank you for your purchase!</h3>
                        <p class="user-name">{{ paymentDetail.customer.first_name+" "+paymentDetail.customer.last_name }}</p>
                        <p class="user-email">{{ paymentDetail.customer.email }}</p>
                    </div>
                    <h2>Payment Amount</h2>
                    <p class="amount">
                        {{ paymentDetail.customer.preferred_currency_code }} {{ paymentDetail.subscription.subscription_items[0].amount / 100 }}.{{ paymentDetail.subscription.subscription_items[0].amount % 100 }}
                    </p>
                    <div class="payment-method">
                        <h3>Payment Method</h3>
                    </div>
                    <div class="payment-info"
                        *ngIf="paymentDetail.customer?.payment_method?.type === 'upi';else otherPaymentType"
                    >
                        <p class="card-type">UPI</p>
                        <p class="card-info">Reference ID: {{ paymentDetail.customer?.payment_method?.reference_id || '-' }}</p>
                    </div>
                    <ng-template #otherPaymentType>
                        <div class="payment-info"
                            *ngIf="paymentDetail?.card?.card_type && paymentDetail?.card?.masked_number"
                        >
                            <p class="card-type">Credit / Debit Card</p>
                            <p class="card-info">{{ paymentDetail.card?.card_type || 'Unknown' }} ending with {{ paymentDetail.card.masked_number }}</p>
                        </div>
                    </ng-template>
                    <a href="/dashboard" class="btn">Go To Dashboard</a>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #loadingSpinner>
    <loading-indicator
    [isVisible]="true"
    class="overlay"
    ></loading-indicator>
</ng-template>